import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { SupernovaFragAnimation } from '../blasts/SupernovaFrag';

registerCollisionAnimation('SUPERNOVA', (ctx, e, config, progress) => {
  SupernovaFragAnimation(ctx, e as any, config, progress);
});
